import { render, staticRenderFns } from "./QuestionTemplatePropagateDialog.vue?vue&type=template&id=5a08ec3b&scoped=true"
import script from "./QuestionTemplatePropagateDialog.vue?vue&type=script&lang=js"
export * from "./QuestionTemplatePropagateDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplatePropagateDialog.vue?vue&type=style&index=0&id=5a08ec3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08ec3b",
  null
  
)

export default component.exports